import React, { useEffect, useState } from "react";
import "./style.css";
import { reload } from "../icons";
import { sendEmail } from "../services/email";
import { Alert, Tooltip } from "@mui/material";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import { numberWithCommas, valueLabelFormat } from '../utils/sliderFunctions'

const ComissionCalculatorResult = ({
  setCalc,
  price,
  dueDiligenceTimeline,
  checkboxState,
}) => {
  const [email, setEmail] = useState('')
  const [name, setName] = useState('')
  const [secure, setSecure] = useState(false)
  var date = new Date()
  const handleCanculate = (e) => {
    setCalc((prev) => !prev)
  }
  const lvrPrice = 0.000780598 * price + 5714.73;
  const codebasePrice = 0.000780598 * price + 5714.73;
  const qoePrice = 0.00226749 * price + 8194.54;
  let result = (lvrPrice * 2)

  /* If the user opts to include deal flow with the Start to Finish Plan */
  if (checkboxState.df) {
    result = result * 1.3
  }

  /* If the user opts to include a QoE with the Start to Finish Plan */
  if (checkboxState.qoe) {
    const additionalQoE = (price, dueDiligenceTimeline) => {
          return qoePrice
    }
    result = result + (additionalQoE(price, dueDiligenceTimeline) * 1.5)
  }

   /* If the user opts to include a Codebase & Tech Stack Review with the Start to Finish Plan */
    if (checkboxState.tsa) {
      const additionaltsa = (price, dueDiligenceTimeline) => {
            return codebasePrice
      }
      result = result + (additionaltsa(price, dueDiligenceTimeline) * 1.5)
    }

/* We do the complete formatting at the end after all calculations are complete */
result = numberWithCommas(Math.floor((result) / 100 + 0.5) * 100)

  return (
    <div className='comission-calculator'>
      <h1>Your Instant Quote</h1>
      <p>
        {/* We believe in pricing transparency. Always know what you are playing. */}
      </p>
      {/* <div className='listing-price-result'>
        <p>Listing Price</p>
        <h1>${price}</h1>
      </div> */}
      <div className='comission-amount'>
        <div className='actual-dollar-amount'>
          <h1>${result}</h1>
          <p>Start to Finish Plan</p>
        </div>
      </div>

      <div className='quote-footer'>
        {/* <Tooltip title='Secure this quote for 30 days.' placement='right'> */}
        <button className='quote_footer_button'>
          <a href='https://rapiddiligence.com/free-consultation' target='_blank'>
            Request a Free Consultation
          </a>
        </button>
        {/* </Tooltip> */}
        <p>Secure this quote for 30 days:</p>
        <div className='form_container'>
          <TextField
            id='outlined-basic'
            label='First Name'
            variant='outlined'
            onChange={(e) => setName(e.target.value)}
          />
          <TextField
            id='outlined-basic'
            label='Email'
            variant='outlined'
            onChange={(e) => setEmail(e.target.value)}
          />
          <Button
            variant='contained'
            onClick={() => {
              sendEmail({
                to: email,
                to_name: name,
                quotes: `Start to Finish Plan: $${result}`,
                price: `${valueLabelFormat(price)}`,
                timeline: 'N/A',
                date: new Date(
                  date.setDate(date.getDate() + 30)
                ).toDateString(),
                setSecure: setSecure,
              })
            }}
          >
            Secure
          </Button>
          {secure ? (
            <Alert severity='success'>
              Your quote is secured and ready for you in your inbox!
            </Alert>
          ) : (
            ''
          )}
        </div>
      </div>
      <a onClick={handleCanculate} className='generate-new-quote'>
        Generate new quote {reload}
      </a>
    </div>
  )
}

export default ComissionCalculatorResult;
